// src/components/landing/WhyDifferent.jsx
import React from 'react';
import { useReveal } from '../../utils/reveal';
import { IconCompliance, IconCalc, IconRuler, IconDesign, IconLimits } from './LandingIcons';

// The credibility section. Calm and exact on purpose: no decoration that competes
// with the text, and nothing here that the product does not actually do.
const ITEMS = [
  { icon: IconCompliance, title: 'The rule is resolved, not chosen.',
    text: 'Where roads of different widths meet the plot, each edge carries its own margin and the strictest governs — the most expensive error in the process is taken off your hands.' },
  { icon: IconCalc, title: 'No AI does the arithmetic.',
    text: 'Every verdict is computed in plain code before a word is generated; the assistant only phrases a figure it was handed. A compliance number is never a guess.' },
  { icon: IconRuler, title: 'Nothing is metres until you say so.',
    text: 'Extraction stays in pixels until a scale is set explicitly — and the interface shows which method set it and how far the methods agreed.' },
  { icon: IconDesign, title: 'Your drawing is the input.',
    text: "A JPG or a PDF at whatever resolution you have. For a practice with no BIM team, that's the difference between an afternoon and a fortnight." },
  { icon: IconLimits, title: 'Honest about its limits.',
    text: "Screening-grade by design, and it says so at every point — a tool that tells you what it doesn't know is one you can rely on for what it does." },
];

export default function WhyDifferent() {
  const ref = useReveal();
  return (
    <section className="lp-section lp-section--alt" aria-labelledby="lp-why-title">
      <div className="lp-wrap">
        <h2 id="lp-why-title" className="lp-h2">Why it&rsquo;s different</h2>
        <ul ref={ref} className="lp-why lp-stagger">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <li key={it.title} className="lp-why-item lp-child" style={{ '--i': i }}>
                <span className="lp-icon" aria-hidden="true"><Icon /></span>
                <div>
                  <h3 className="lp-h3">{it.title}</h3>
                  <p className="lp-body">{it.text}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
